export default (styledObj) => styledObj.componentStyle.rules.join('');
